import * as React from "react";
import { Button, withStyles } from "@material-ui/core";
import Remove from "@material-ui/icons/AddCircle";
import classNames from "classnames";

const styles = (theme) => ({
  button: {
    width: "98%",
    minWidth: "230px",
    padding: "7px 15px",
    fontFamily: "Raleway",
    fontSize: "12px",
    fontWeight: 400,
    textTransform: "none" as any,
    borderRadius: "0px",
    display: "flex",
    justifyContent: "center",
  },
  buttonRoot: {
    boxShadow: "0px 2px 3px 0px #CFCFCF",
    border: "1px solid #CFCFCF",
    backgroundColor: "#ffffff",
    color: "rgba(0,0,0,0.87)",
  },
  buttonRootLinked: {
    border: "1px solid #C5C5C5",
    backgroundColor: "#f2f2f2",
    color: "#A5A5A5",
  },
  buttonLabel: {
    height: "20px",
  },
  img: {
    height: "18px",
    marginRight: "15px",
  },
  imgLinked: {
    height: "18px",
    marginRight: "15px",
    filter: "grayscale(100%)",
  },
  icon: {
    fontSize: "18px",
    marginRight: "15px",
  },
  iconLinked: {
    fontSize: "18px",
    marginRight: "15px",
    color: "#a2a2a2",
  },
  hoverLinked: {
    "&:hover": {
      color: "rgba(0,0,0,0.87)",
      backgroundColor: "#FFFFFF",
    },
    "&:hover > span > img": {
      filter: "unset",
    },
  },
  iconRemove: {
    transition: "color 200ms ease-in",
    cursor: "pointer",
    color: "#c1c1c1",
    fontSize: "20px",
    transform: "rotate(45deg)",
    marginLeft: "10px",
    "&:hover": {
      color: "#ABC200",
    },
  },
  hoverFacebook: {
    "&:hover": {
      color: "#FFFFFF",
      backgroundColor: "#3C5A99",
    },
  },
  hoverLinkedin: {
    "&:hover": {
      color: "#FFFFFF",
      backgroundColor: "#346DA6",
    },
  },
  hoverGoogle: {
    "&:hover": {
      color: "#FFFFFF",
      backgroundColor: "#B7B7B7",
    },
  },
});

function AccountButton(props) {
  const { classes, text, onClick, image, Icon, hover, linked } = props,
    buttonClasses = {
      root: linked ? classes.buttonRootLinked : classes.buttonRoot,
      label: classes.buttonLabel,
    },
    hoverClass = linked
      ? classes.hoverLinked
      : hover === "facebook"
      ? classes.hoverFacebook
      : hover === "linkedin"
      ? classes.hoverLinkedin
      : hover === "google"
      ? classes.hoverGoogle
      : null;
  return (
    <Button
      className={classNames(classes.button, hoverClass)}
      classes={buttonClasses}
      {...(!linked && { onClick })}
    >
      {image && (
        <img className={linked ? classes.imgLinked : classes.img} src={image} />
      )}
      {Icon && <Icon className={linked ? classes.iconLinked : classes.icon} />}
      {text}
      {linked && <Remove className={classes.iconRemove} onClick={onClick} />}
    </Button>
  );
}

export default withStyles(styles)(AccountButton);



// WEBPACK FOOTER //
// ./src/common/components/AccountButton.tsx